/* assets/audio-gate.js — hide form on unlock, show "thanks", persist via localStorage */
(() => {
  const FORM_ID   = "TBgnh7"; // .klaviyo-form-TBgnh7
  const AUDIO_URL = "https://cdn.shopify.com/s/files/1/0803/0332/5511/files/COMMONSENSETEASER.mp3?v=1756417208";
  const KEY       = "audioGateUnlocked";
  const log = (...a) => console.debug("[audio-gate]", ...a);

  function hideFormShowThanks(tries = 40) {
    const formHost = document.querySelector(".klaviyo-form-" + FORM_ID);
    const thanks   = document.getElementById("ag-thanks");
    if (!formHost) {
      if (tries > 0) setTimeout(() => hideFormShowThanks(tries - 1), 150);
      return false;
    }
    formHost.style.display = "none";
    if (thanks) thanks.style.display = "flex";
    return true;
  }

  function revealAudio() {
    const wrap  = document.getElementById("klaviyo-audio-wrap");
    const audio = document.getElementById("gated-audio");
    if (!wrap || !audio) return;
    if (!audio.src) {
      audio.src = AUDIO_URL;
      audio.controlsList = "nodownload";
    }
    wrap.style.display = "flex";
  }

  function unlock() {
    hideFormShowThanks();
    revealAudio();
    try { localStorage.setItem(KEY, "1"); } catch(_) {}
    log("unlocked");
  }

  // Persisted unlock on refresh
  try { if (localStorage.getItem(KEY) === "1") unlock(); } catch(_) {}

  // Listen for Klaviyo’s event if it fires
  document.addEventListener("klaviyoForms", (e) => {
    const d = e?.detail || {};
    if (d.type === "submit" && d.success && d.formId === FORM_ID) unlock();
  });

  // Watch for success UI swap (covers most cases)
  function watchContainer() {
    const container = document.querySelector(".klaviyo-form-" + FORM_ID);
    if (!container) return setTimeout(watchContainer, 300);
    log("watching container");
    if ("MutationObserver" in window) {
      const mo = new MutationObserver((muts) => {
        for (const m of muts) {
          // look for common success markers or success-y text
          const successSel = '[data-testid="form-success"], .klaviyo-form-success, [role="alert"], [data-testid*="success"]';
          const hasSuccess = (
            m.target.querySelector?.(successSel) ||
            Array.from(m.addedNodes || []).some(n => (n.querySelector?.(successSel) || /thank|success|subscribed|you.?re in/i.test((n.textContent||""))))
          );
          if (hasSuccess) { mo.disconnect(); unlock(); return; }
        }
      });
      mo.observe(container, { childList: true, subtree: true });
    }
  }

  if (document.readyState !== "loading") watchContainer();
  else document.addEventListener("DOMContentLoaded", watchContainer);
})();